import React, { useState } from "react";
import features from "../../utils/Schedulif";
import arrow from "../../assets/tab-arrow.svg";
import arrowBlack from "../../assets/tab-arrow-black.svg";
import "../../Schedulif.css";
import Shopify from "../../assets/badge-shopify-app-store-dark.png";
import { Helmet } from "react-helmet-async";

const Schedulif = () => {
  const [faq, setFaq] = useState(1);
  const [activeFeature, setActiveFeature] = useState(features[0]);

  return (
    <div className="page_content page_padding">
      <Helmet>
        <title>Schedulify - Theme Scheduler for Shopify</title>
        <meta name="title" content="Schedulify - Theme Scheduler for Shopify" />
        <meta
          name="description"
          content="Schedulify is a Shopify app that automates theme publishing for sales, launches, and seasonal campaigns so your store goes live on time, every time."
        />
      </Helmet>
      <section className="landing-hero-banner">
        <div className="container">
          <div className="landing-hero-banner-wrap">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div className="landing-hero-banner-desc">
                  <div className="schedulify-badge">
                    <div className="icon-box">
                      <img src="images/Schedulify-icon.svg" alt="Schedulify" />
                    </div>
                    <div className="schedulify-txt">
                      <span className="txt-green">Schedulify</span>
                      <p>Theme Scheduler</p>
                    </div>
                  </div>
                  <div className="schedulify-desc">
                    <p className="tag-line">
                      Automate <span className="txt-green">your</span> theme
                      changes <span className="txt-green">for</span> promotions,
                      seasons, <span className="txt-green">and</span> campaigns.
                    </p>
                    <h1>
                      Schedulify{" "}
                      <span className="txt-green"> - Theme Scheduler for</span>{" "}
                      Shopify
                    </h1>
                    <p>
                      Stop switching themes manually at midnight. With
                      Schedulify, you plan your publishes in advance and let
                      your storefront update itself automatically and
                      accurately.
                    </p>
                    <div>
                      <a
                        href="https://apps.shopify.com/schedulify-theme-scheduler"
                        target="_blank"
                        className=""
                        rel="noopener noreferrer"
                      >
                        <img
                          src={Shopify}
                          className="with-bg"
                          alt="Available on Shopify App Store"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <div className="schedulify-img">
                  <img
                    src="images/Schedulify-banner.png"
                    alt="Schedulify – Theme Scheduler for Shopify"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="landing-merchants-love section-padding section-bg">
        <div className="container">
          <div className="landing-merchants-love-wrap">
            <div className="section-title text-center">
              <h2>
                Why Merchants Love{" "}
                <span className="txt-green"> Schedulify</span>
              </h2>
              <p>
                Shopify stores run round-the-clock. But merchants shouldn’t have
                to.
              </p>
            </div>
            <div className="landing-merchants-main">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div className="landing-merchants-box">
                    <div className="icon-box">
                      <img
                        src="images/launches.svg"
                        alt="Stress-free theme launches"
                      />
                    </div>
                    <h3>98%</h3>
                    <p>Stress-free theme launches</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div className="landing-merchants-box">
                    <div className="icon-box">
                      <img
                        src="images/Faster.svg"
                        alt="Faster campaign execution"
                      />
                    </div>
                    <h3>3X</h3>
                    <p>Faster campaign execution</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                  <div className="landing-merchants-box">
                    <div className="icon-box">
                      <img
                        src="images/Automation.svg"
                        alt="Set once & publish automatically"
                      />
                    </div>
                    <h3>100% Automation</h3>
                    <p>Set once & publish automatically</p>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="landing-merchants-bottom-desc text-center">
                    <p>
                      Schedulify removes the stress of timing your storefront
                      look with your campaigns. Whether it's a midnight sale,
                      weekend product launch, or seasonal theme update your
                      theme publishes itself without manual effort.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="how-it-works section-padding">
        <div className="container">
          <div className="how-it-works-wrap">
            <div className="section-title text-center">
              <h2>
                How It <span className="txt-green"> Works</span>
              </h2>
              <p>Step-by-Step Visual Section</p>
            </div>
            <div className="how-it-works-steps">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-6 col-lx-6 col-xl-6">
                  <div className="how-it-works-steps-card">
                    <div className="how-it-works-steps-card-desc">
                      <div className="steps">STEP 1</div>
                      <h3>Select a Theme</h3>
                      <p>
                        Pick any unpublished theme you’ve prepared in your
                        store. Duplicate, customize, or design a new
                        one—Schedulify supports all of them.
                      </p>
                      <em>No coding, no manual toggling.</em>
                    </div>
                    <div className="how-it-works-steps-card-img">
                      <img src="images/step-1.png" alt="Select a Theme" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lx-6 col-xl-6">
                  <div className="how-it-works-steps-card">
                    <div className="how-it-works-steps-card-desc">
                      <div className="steps">STEP 2</div>
                      <h3>Set the Publish Time</h3>
                      <p>
                        Choose the exact date, hour, and minute for your theme
                        to go live. Perfect for launches, campaigns, festival
                        sales, and midnight events.
                      </p>
                    </div>
                    <div className="how-it-works-steps-card-img">
                      <img src="images/step-2.png" alt="Set the Publish Time" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lx-6 col-xl-6">
                  <div className="how-it-works-steps-card">
                    <div className="how-it-works-steps-card-desc">
                      <div className="steps">STEP 3</div>
                      <h3>Save & Schedule</h3>
                      <p>
                        Schedulify locks in your schedule and monitors it for
                        accuracy.
                      </p>
                      <p>
                        No need to stay online—your theme is queued and ready to
                        deploy.
                      </p>
                    </div>
                    <div className="how-it-works-steps-card-img">
                      <img src="images/step-3.png" alt="Save & Schedule" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 col-lx-6 col-xl-6">
                  <div className="how-it-works-steps-card">
                    <div className="how-it-works-steps-card-desc">
                      <div className="steps">STEP 4</div>
                      <h3>Relax</h3>
                      <p>
                        Your storefront updates automatically—even while you
                        sleep.
                      </p>
                      <p>
                        Enjoy peace of mind knowing your campaigns stay
                        perfectly on time.
                      </p>
                    </div>
                    <div className="how-it-works-steps-card-img">
                      <img src="images/step-4.png" alt="Relax" />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-12 col-lx-12 col-xl-12">
                  <div className="schedule-btn">
                    <a href="https://apps.shopify.com/schedulify-theme-scheduler">
                      Schedule Your First Theme{" "}
                      <img src="images/btn-arrow.svg" alt="btn-arrow" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="feature-highlights section-bg section-padding">
        <div className="container">
          <div className="feature-highlights-wrap">
            <div className="section-title text-center">
              <h2>
                <span className="txt-green">Feature</span> Highlights
              </h2>
            </div>
          </div>
          <div className="feature-highlights-tabs">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="feature-nav d-none d-md-block" id="featureNav">
                  {features.map((item) => (
                    <div
                      key={item.title}
                      className={`nav-item ${
                        activeFeature.title === item.title ? "active" : ""
                      }`}
                      data-index="0"
                      onClick={() => setActiveFeature(item)}
                    >
                      <div className="text">{item.title}</div>
                      <div className="chev" aria-hidden="true">
                        <img src="images/tab-arrow.svg" alt="tab-arrow" />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="d-md-none">
                  <div className="accordion" id="featureAccordion">
                    {features.map((item) => (
                      <div className="accordion-item" key={item.title}>
                        <h2 className="accordion-header" id="heading0">
                          <button
                            className={`accordion-button ${
                              activeFeature.title !== item.title && "collapsed"
                            }`}
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapse0"
                            aria-expanded="true"
                            aria-controls="collapse0"
                            data-index="0"
                            style={{
                              "--arrow": `url(${arrow})`,
                              "--arrow-black": `url(${arrowBlack})`,
                            }}
                            onClick={() => setActiveFeature(item)}
                          >
                            {item.title}
                          </button>
                        </h2>
                        {activeFeature.title === item.title && (
                          <div
                            id="collapse0"
                            className="accordion-collapse collapse show"
                            aria-labelledby="heading0"
                            data-bs-parent="#featureAccordion"
                          >
                            <div className="accordion-body">
                              <div className="feature-card">
                                <img
                                  src={item.icon}
                                  alt="Schedule Theme Publishes"
                                  className="icon"
                                />
                                <h4 id="mobileTitle0">{item.title}</h4>
                                <p id="mobileDesc0">{item.desc}</p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 d-none d-md-flex justify-content-center">
                <div className="feature-card" id="featureCard">
                  <img
                    src={activeFeature?.icon}
                    alt="icon"
                    className="icon"
                    id="cardIcon"
                  />
                  <h4 id="cardTitle">{activeFeature?.title}</h4>
                  <p id="cardDesc">{activeFeature?.desc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="who-for section-padding">
        <div className="container">
          <div className="who-for-wrap">
            <div className="section-title text-center">
              <h2>Who It's For</h2>
            </div>
          </div>
          <div className="who-for-cards">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="who-for-card gradient-bg-01">
                  <div className="icon-box">
                    <img
                      src="images/Who-For-img-01.svg"
                      alt="Shopify merchants running regular promos"
                    />
                  </div>
                  <h4>Shopify merchants running regular promos</h4>
                  <p>
                    Ideal for stores that frequently run flash sales, festival
                    discounts, product drops, and weekend promotions. Automate
                    theme updates so you never have to manually switch themes at
                    odd hours.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="who-for-card gradient-bg-02">
                  <div className="icon-box">
                    <img
                      src="images/Who-For-img-02.svg"
                      alt="D2C brands with marketing campaigns"
                    />
                  </div>
                  <h4>D2C brands with marketing campaigns</h4>
                  <p>
                    Perfect for brands planning coordinated launches with ads,
                    email marketing, SMS pushes, and influencer collaborations.
                    Ensure your storefront look matches your campaign timing for
                    higher conversions.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="who-for-card gradient-bg-03">
                  <div className="icon-box">
                    <img
                      src="images/Who-For-img-03.svg"
                      alt="Seasonal businesses (fashion, gifting, decor)"
                    />
                  </div>
                  <h4>Seasonal businesses (fashion, gifting, decor)</h4>
                  <p>
                    Switch between seasonal collections like Diwali, Christmas,
                    Black Friday, Valentine’s, Summer, Winter, and more. Plan
                    your theme changes months ahead and stay visually relevant
                    year-round.
                  </p>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <div className="who-for-card gradient-bg-04">
                  <div className="icon-box">
                    <img
                      src="images/Who-For-img-04.svg"
                      alt="Agencies managing multiple client stores"
                    />
                  </div>
                  <h4>Agencies managing multiple client stores</h4>
                  <p>
                    Save time by automating theme scheduling across multiple
                    Shopify stores. No need to log in repeatedly—set schedules
                    and manage theme changes from one organized workflow.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="faq section-bg section-padding">
        <div className="container">
          <div className="faq-wrap">
            <div className="section-title text-center">
              <h2>Frequently Asked Questions (FAQ)</h2>
            </div>
            <div className="accordion" id="faqAccordion">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    type="button"
                    className={`accordion-button ${faq !== 1 && "collapsed"}`}
                    data-bs-toggle="collapse"
                    data-bs-target="#faq1"
                    onClick={() => setFaq(1)}
                  >
                    Will scheduling a theme affect my current theme settings?
                  </button>
                </h2>
                {faq === 1 && (
                  <div
                    id="faq1"
                    className={`accordion-collapse collapse ${
                      faq === 1 && "show"
                    }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      No—each theme keeps its own settings. Only publishing
                      changes.
                    </div>
                  </div>
                )}
              </div>
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${faq !== 2 && "collapsed"}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq2"
                    onClick={() => setFaq(2)}
                  >
                    Do I need coding knowledge?
                  </button>
                </h2>
                {faq === 2 && (
                  <div
                    id="faq2"
                    className={`accordion-collapse collapse ${
                      faq === 2 && "show"
                    }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      No, you don’t need any coding knowledge to use this
                      feature.
                    </div>
                  </div>
                )}
              </div>
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${faq !== 3 && "collapsed"}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq3"
                    onClick={() => setFaq(3)}
                  >
                    Can I schedule multiple themes?
                  </button>
                </h2>
                {faq === 3 && (
                  <div
                    id="faq3"
                    className={`accordion-collapse collapse ${
                      faq === 3 && "show"
                    }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes, you can schedule multiple themes.
                    </div>
                  </div>
                )}
              </div>
              <div className="accordion-item mt-3">
                <h2 className="accordion-header">
                  <button
                    className={`accordion-button ${faq !== 4 && "collapsed"}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#faq4"
                    onClick={() => setFaq(4)}
                  >
                    What happens if Shopify publishes a theme delay?
                  </button>
                </h2>
                {faq === 4 && (
                  <div
                    id="faq4"
                    className={`accordion-collapse collapse ${
                      faq === 4 && "show"
                    }`}
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      The scheduled theme will publish at the next available
                      window.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Schedulif;
